import { Accordion, IAccordionTab } from '@/common/ui/containers/Accordion/Accordion';
import { LocationMap } from '@/common/ui/maps/LocationMap/LocationMap';
import * as S from './ActivityTabs.styles';

type ActivityTabsProps = {
    tabs: IAccordionTab[];
    latitude?: string;
    longitude?: string;
    address?: string;
    handleClickOnTab: (value: number) => void;
    indexOpen: number | null;
};

export const ActivityTabs = ({
    tabs,
    latitude,
    longitude,
    address,
    handleClickOnTab,
    indexOpen,
}: ActivityTabsProps) => {
    return (
        <Accordion
            tabs={tabs}
            handleClickOnTab={handleClickOnTab}
            indexOpen={indexOpen}
            map={
                latitude &&
                longitude && (
                    <S.LocationStyle>
                        <LocationMap latitude={latitude} longitude={longitude} address={address} />
                    </S.LocationStyle>
                )
            }
            withStars
        />
    );
};
